module.exports = __webpack_public_path__ + "static/media/search-24px.67409700.svg";